export default "__VITE_ASSET__DSja9ia8__"